module.exports = __webpack_public_path__ + "static/media/Arbitrum_HorizontalLogo-dark.b8934e8e.svg";